export default __webpack_public_path__ + "static/media/artist_charly.18aaa006.jpg";